// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__9ot5j","active":"downloadDropdown_active__2jL_U"};